import { EventTypes } from 'types/events'
import { useProtectionWaiver, useIsTicketWritable } from 'hooks/tickets'
import { useSelector } from 'react-redux'
import { selectCurrentUser, selectTicket } from 'redux/appStore'
import { useServiceProxy } from 'hooks/kong'
import { ProviderNames } from 'hooks/dispatch/utils'
import { FeesByServiceType, MaxFeeByServiceType, useGetFeesFromForm } from 'components/Waivers/WaiverFee'

export const useUpdateTicketCharges = () => {
  const { ticketNumber, brandId } = useSelector(selectTicket)
  const currentUser = useSelector(selectCurrentUser)
  const hasRoadsideProtection = useProtectionWaiver()
  const isWritable = useIsTicketWritable()
  const serviceProxy = useServiceProxy()
  const getFeesFromForm = useGetFeesFromForm()

  return async (eventType: EventTypes, provider: ProviderNames) => {
    let chargeAmount = 0.0

    if (isWritable && !hasRoadsideProtection && getFeesFromForm) {
      try {
        // there can be multiple charges for soft services. loop through each of them and send misc charge
        for (const charge of getFeesFromForm) {
          if (provider) {
            chargeAmount = FeesByServiceType[charge]?.[provider] ?? 0
          } else {
            chargeAmount = MaxFeeByServiceType[charge]
          }

          await serviceProxy(
            'POST',
            `/serviceproxy/ticket/${ticketNumber}/miscCharge`,
            {},
            {
              createdUserId: currentUser!.nameID,
              chargeDescription: charge,
              chargeAmount: chargeAmount.toString(),
            },
          )
        }
      } catch (e) {
        console.error(e)
      }
    }
  }
}

export default useUpdateTicketCharges
